import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    // updateViaCache: 'none' garante que o proprio script do SW nunca vem do
    // HTTP cache (nem os 24h default do Chrome). Combinado com Cache-Control
    // no-cache no nginx, a cada visita o browser detecta SW novo imediato.
    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
      .then((reg) => {
        // Checa novidade a cada carregamento da pagina.
        if (reg && typeof reg.update === 'function') reg.update().catch(() => {});
      })
      .catch(console.error);
  });
}